export const HEADER_HEIGHT = '4rem';
export const BOTTOM_NAV_HEIGHT = '4rem';
/** Bottom navigation height including the device's home-indicator inset. */
export const BOTTOM_NAV_SAFE_HEIGHT = `calc(${BOTTOM_NAV_HEIGHT} + env(safe-area-inset-bottom, 0px))`;
export const CONTENT_PADDING_WIDTH = '1.5rem';
